import React from 'react';

import {observer} from 'mobx-react';
import {GameCenterHeaderModuleProps} from "../../../models/game-center-header-module.props";
import {GameCenterHeaderModuleDetailsStatusGameTime} from "./game-center-header-module.details.status-game-time";
import {GameCenterHeaderModuleDetailsStatusGameTopScore} from "./game-center-header-module.details.status-top-score";

export class GameCenterHeaderModuleDetailsStatusGameProps extends GameCenterHeaderModuleProps {
}

export const GameCenterHeaderModuleDetailsStatusGame = observer(({controller}: GameCenterHeaderModuleDetailsStatusGameProps) => {
  return (
    <>
      <GameCenterHeaderModuleDetailsStatusGameTopScore controller={controller}/>
      <GameCenterHeaderModuleDetailsStatusGameTime controller={controller}/>
    </>
  );
});
